/**
 * Lovasok Marketplace - App bundle (csak marketplace felületek)
 *
 * Nevesített Alpine komponensek + LovasokAPI. Betöltését a
 * Lovasok_Marketplace_Public_Assets::enqueue_scripts() a get_page_context()
 * alapján gate-eli. Az Alpine core az alpine-chrome.min.js-ben van; a
 * komponensek az alpine:init eseményben regisztrálnak, amit a chrome
 * bundle az Alpine.start() előtt lő ki.
 *
 * @package Lovasok_Marketplace
 */

import horseSearch from './components/horse-search.js';
import dashboard from './components/dashboard.js';
import stableManager from './components/stable-manager.js';
import cart from './components/cart.js';
import checkout from './components/checkout.js';
import messages from './components/messages.js';
import reminders from './components/reminders.js';
import createListing from './components/create-listing.js';
import horseDetail from './components/horse-detail.js';

import { LovasokAPI } from './utils/api.js';
import * as formatters from './utils/formatters.js';

document.addEventListener('alpine:init', () => {
    window.Alpine.data('horseSearch', horseSearch);
    window.Alpine.data('dashboard', dashboard);
    window.Alpine.data('stableManager', stableManager);
    window.Alpine.data('cartPage', cart);
    window.Alpine.data('checkoutPage', checkout);
    window.Alpine.data('messagingSystem', messages);
    window.Alpine.data('reminderSystem', reminders);
    window.Alpine.data('createListingWizard', createListing);
    window.Alpine.data('horseDetail', horseDetail);

    window.Alpine.store('remindersApp', {
        upcoming: 0,
        overdue: 0
    });
});

window.LovasokAPI = LovasokAPI;
window.LovasokFormatters = formatters;
